import * as React from 'react';

import ExportComponent from '../../../components/NetworksPage/Export/Export';
import { ExportLocale } from '../../../components/NetworksPage/Export/export.locale';

interface ExportProps {
  locale: ExportLocale;
  exportNetworks: (type: 'json' | 'tsv') => void;
}

interface ExportState {
  isDropDownOpen: boolean;
}

class Export extends React.PureComponent<ExportProps, ExportState> {
  state = {
    isDropDownOpen: false,
  };
  containerRef: HTMLDivElement | null = null;

  componentDidMount() {
    document.addEventListener('click', e => {
      const target = e.target as Node;
      if (this.containerRef && !this.containerRef.contains(target)) {
        this.closeDropDown();
      }
    });
  }

  toggleDropDown = () =>
    this.setState(prevState => ({ isDropDownOpen: !prevState.isDropDownOpen }));
  openDropDown = () => this.setState({ isDropDownOpen: true });
  closeDropDown = () => this.setState({ isDropDownOpen: false });

  render() {
    return (
      <ExportComponent
        locale={this.props.locale}
        toggleDropDown={this.toggleDropDown}
        closeDropDown={this.closeDropDown}
        openDropDown={this.openDropDown}
        exportNetworks={this.props.exportNetworks}
        isDropDownOpen={this.state.isDropDownOpen}
        containerRef={el => (this.containerRef = el)}
      />
    );
  }
}

export default Export;



// WEBPACK FOOTER //
// /www/client/src/containers/NetworksPage/Export/Export.tsx